// "Development" enabled environment

export const environment = {
    production: false,
    showReports: true,
    appConfig: 'appconfig.development.json',
};
